import { endpoints } from './endpoints';
import { request } from './http';

export const uploads = {
    uploadCer(file: File): Promise<unknown> {
        const formData = new FormData();
        formData.append('upload', file);
        return request<unknown>(endpoints.uploads.cer(), {
            method: 'POST',
            formData,
        });
    },
    uploadKey(file: File, password: string): Promise<unknown> {
        const formData = new FormData();
        formData.append('upload', file);
        formData.append('password', password);
        return request<unknown>(endpoints.uploads.key(), {
            method: 'POST',
            formData,
        });
    },
    uploadLogo(file: File, extension: string): Promise<{ logoUrl: string }> {
        return request<{ logoUrl: string }>(endpoints.uploads.logo(extension), {
            method: 'POST',
            rawBody: file,
        });
    },
};
